import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'
import runWorkflowStepMutation from './mutation'
import { IRunWorkflowStepResponse, IRunWorkflowStepVariables } from './types'

/**
 * Hook declaration for the `runWorkflowStep` mutation.
 *
 * `no-cache` is a *default*, written before the spread like the other order
 * and cart mutations: the result carries no identity, so there is nothing a
 * cache write could serve later. No caller passes a policy.
 *
 * Leave `errorPolicy` at Apollo's default. Under it the mutate function
 * rejects on a refusal, and `useWorkflowStep` classifies every failure in its
 * catch; `'all'` would resolve with `data: null` instead and the hook would
 * read a 429 as a trigger that answered nothing.
 * @internal
 */
const useRunWorkflowStepMutation = (
  options?: MutationHookOptions<
    IRunWorkflowStepResponse,
    IRunWorkflowStepVariables
  >,
): MutationTuple<IRunWorkflowStepResponse, IRunWorkflowStepVariables> => {
  return useMutation<IRunWorkflowStepResponse, IRunWorkflowStepVariables>(
    runWorkflowStepMutation,
    {
      fetchPolicy: 'no-cache',
      ...options,
    },
  )
}

export default useRunWorkflowStepMutation
